import React from 'react'
import { Button } from "@chakra-ui/react"

const ButtonBox = (props) => {
    const {size="md", name="", maxWidth, icon = null, onClick=null, variant="surface", colorPalette=null, type='button', borderRadius="", disabled=false,} = props;
  return (
    <Button borderRadius={borderRadius} maxW={maxWidth} size={size} onClick={onClick} variant={variant} colorPalette={colorPalette} type={type} disabled={disabled}>
        {icon && icon} {name}
    </Button>
  )
}

export default ButtonBox
